<div class="col-md-10">
  <div class="col-md-10 border">
    <form [formGroup]="searchmeetingform" style="padding:20px;">
      <div class="col-md-10"><b>
          <p>Sök möte för {{institution.shortName}} {{institution.name}}</p>
        </b></div>
      <hr />
      <div class="row">
        <div class="col-lg-4 col-md-10 col-sm-8 form-group">
          <label for="fromdate">
            Från datum
          </label>
          <input type="text" class="form-control form-control-sm dateinput" mask="0000-00-00" formControlName="FromDate" format="YYYY-mm-dd" id="fromdate" placeholder="YYYY-MM-DD">
        </div>
        <div class="col-lg-4 col-md-12 col-sm-8 form-group">
          <label for="todate">
            Till datum
          </label>
          <input type="text" class="form-control form-control-sm dateinput" mask="0000-00-00"  formControlName="ToDate" format="YYYY-mm-dd" id="todate" placeholder="YYYY-MM-DD">
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 form-group">
          <label for="issue">
            Rubrik
          </label>
          <input type="text" class="form-control form-control-sm" id="issue" maxlength="30" formControlName="issue">
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 form-group">
          <label for="comment">
            Kommentar
          </label>
          <input type="text" class="form-control form-control-sm" id="comment" formControlName="comment">
        </div>
      </div>
      <br>
      <div class="row col-md-12">
        <mat-radio-group aria-label="Mötestyp" formControlName="meetingTypeId">
          <mat-radio-button value="1">Ordinarie</mat-radio-button>
          <mat-radio-button value="2">Sommarmöte</mat-radio-button>
          <mat-radio-button value="3">Övrigt möte</mat-radio-button>
          <mat-radio-button value="">Alla</mat-radio-button>
        </mat-radio-group>
      </div>
      <br>
      <span><button class="btn border" style="max-width:75px;" (click)="search()">Sök</button>
        <button class="btn border" style="margin-left: 20px;" (click)="close()">Avbryt</button>
        <button class="btn border" style="margin-left: 20px;" (click)="addMeeting()">Registrera möte</button>
      </span>
    </form>
  </div>
  <div *ngIf="resultlist.length > 0" class="col-md-8" style="min-width: 1200px;">
    <div class="resultdiv">
      <p-menubar [model]="items">
        <div>
          Resultat: {{resultlist?.length}}
        </div>
      </p-menubar>
      <table *ngIf="!type" matSort (matSortChange)="sortData($event)" class="table" matSortDisableClear=true>
        <thead role="rowgroup">
          <tr>
            <th mat-sort-header="meetingDate">Datum</th>
            <th mat-sort-header="issue">Rubrik</th>
            <th mat-sort-header="comment">Kommentar</th>
            <th mat-sort-header="meetingTypeName">Mötestyp</th>
            <th mat-sort-header="numberOfAttendances">Antal</th>
            <th></th>
          </tr>
        </thead>
        <tr *ngFor="let m of resultlist;">
          <td><a [routerLink]="['/meetings/meetings/meetingdetails']" [queryParams]="{id: m.id, institutionid: institution.id}">{{m.meetingDate | date: 'yyyy-MM-dd'}}</a></td>
          <td>{{m.issue}}</td>
          <td>{{m.comment}}</td>
          <td>{{m.meetingTypeName}}</td>
          <td>{{m.numberOfAttendances}}</td>
        </tr>
      </table>
      <table *ngIf="type === 'calendar'" class="table table-striped border" matSort (matSortChange)="sortData($event)" matSortDisableClear=true>
        <thead role="rowgroup">
          <tr>
            <th mat-sort-header="meetingTypeName">Mötestyp</th>
            <th mat-sort-header="issue">Rubrik</th>
            <th mat-sort-header="comment">Kommentar</th>
            <th mat-sort-header="meetingDate">Datum</th>
            <th mat-sort-header="numberOfAttendances">Antal</th>
            <th></th>
          </tr>
        </thead>
        <tr *ngFor="let m of resultlist">
          <td>{{m.meetingTypeName}}</td>
          <td>{{m.issue}}</td>
          <td>{{m.comment}}</td>
          <td *ngIf="institutionaccess?.view_meeting_details"><a [routerLink]="['/meetings/meetings/meetingdetails']" [queryParams]="{id: m.id, institutionid: institution.id}">{{m.meetingDate | date: 'yyyy-MM-dd'}}</a></td>
          <td *ngIf="!institutionaccess?.view_meeting_details">{{m.meetingDate | date: 'yyyy-MM-dd'}}</td>
          <td>{{m.numberOfAttendances}} närv. ({{m.numberOfOwnInstitutionAttendances}} egna, {{m.numberOfGuestAttendances}} gäst.)</td>
        </tr>
      </table>
    </div>
  </div>
</div>

<p-dialog header="Registrera möte för {{institutiondata?.shortName}} {{institutiondata?.name}}" [(visible)]="addmeetingview" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true">
  <app-addmeeting [institution]=institutiondata (closeAddMeeting)="closeAddMeeting($event)"></app-addmeeting>
</p-dialog>